import React from "react";
import Img0 from "../images/portada/portada-01.png";
import { Fade } from "react-awesome-reveal";

const Portada = () => {
  return (
    <header>
      <div className="container">
        
          <div className="text">
          <Fade cascade triggerOnce>
            <div className="cinta bg-purple">10 años</div>
            <h1>Fundación Gustavo Mohme Llona</h1>
            <h2>Memoria</h2>
            <p>2014-2024</p>
            <a href="https://fundacionmohme.org/wp-content/uploads/2024/05/Memoria-Fundacion-Mohme_2024.pdf" download>
              <p className="btn-descargar">Descargar PDF</p>
            </a>
            </Fade>
          </div>
        
          <div className="collage">
          <Fade cascade delay="200" triggerOnce>
            <img src={Img0} className="img-0" alt="Gustavo Mohme Llona" />
            </Fade>
          </div>
        
      </div>
    </header>
  );
};

export default Portada;
